import { Link } from "react-router-dom";
import AppLogo from "../ui/AppLogo";

const Footer = () => {
  const footerLinks = {
    left: [
      { name: "Features", href: "#features" },
      { name: "Pricing", href: "#pricing" },
    ],
    right: [
      { name: "FAQs", href: "#faqs" },
      { name: "Contact us", href: "#contact" },
    ],
  };

  return (
    <footer className="w-full bg-white border-t border-gray-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-[80vw] mx-auto">
        {/* Main Footer Content */}
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-8 mb-8">
          {/* Logo and Tagline Section */}
          <div className="lg:max-w-md">
            <Link to="/">
              <AppLogo />
            </Link>
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 leading-tight">
              The Future of Fleet Management:
              <br />
              Smarter, Faster, More Profitable
            </h3>
          </div>

          {/* Navigation Links */}
          <div className="flex flex-col sm:flex-row gap-8 lg:gap-16">
            <div className="flex flex-col gap-4">
              {footerLinks.left.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-gray-600 hover:text-gray-900 transition-colors duration-200 text-base"
                >
                  {link.name}
                </a>
              ))}
            </div>
            <div className="flex flex-col gap-4">
              {footerLinks.right.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-gray-600 hover:text-gray-900 transition-colors duration-200 text-base"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center pt-8 border-t border-gray-100 gap-4">
          <p className="text-sm text-gray-500">©2024. All reserved rights</p>
          <div className="flex gap-6">
            <a
              href="#privacy"
              className="text-sm text-gray-500 hover:text-gray-700 transition-colors duration-200"
            >
              Privacy
            </a>
            <a
              href="#policy"
              className="text-sm text-gray-500 hover:text-gray-700 transition-colors duration-200"
            >
              Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
